import "preact/debug";
import { AppRootReact } from "./app-root-react";
// import { AppRoot2 } from "./app-root-2";
import { h, hydrate, render } from "preact";

const host = document.querySelector("app-root")!;

if (import.meta.env.PUBLIC_SSR_CLIENT) {
  if (typeof window.requestIdleCallback !== "function") {
    window.requestIdleCallback = function (cb): number {
      return window.setTimeout(() => {
        const start = Date.now();
        cb({
          didTimeout: false,
          timeRemaining: () => Math.max(0, 50 - (Date.now() - start)),
        });
      }, 1) as unknown as number;
    };
  }

  hydrate(h(AppRootReact, { host }), host);
} else {
  render(h(AppRootReact, { host }), host);
}
